module.exports = __webpack_public_path__ + "static/S-Factor_Newsletter_AugSept2020-1d82273293ec4b0ff6c3d36a37c22783.pdf";